import React from 'react';

export const EvaluatorPortalStateContext = React.createContext(null);

